import React from 'react';
import LeaveCalendarPresenter from './LeaveCalendarPresenter';

function DashboardCalendarController() {
  return <LeaveCalendarPresenter />;
}

export default DashboardCalendarController;
